module.exports = __webpack_public_path__ + "img/ai-img-ej.48cb3f6b.png";